






























































































































































































































































































































































































































































































































































































import { Getter, Action } from "vuex-class";
import { City } from "@/shared/models/city";
import { ListModel } from "@/shared/models/listModel";
import { reservationStatuses } from "@/shared/models/vReservation";
import DateField from "@/components/misc/DateField.vue";
import * as _ from "lodash";
import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { AccomodationUnitStatus } from "@/shared/models/accomodationUnitStatus";
import { AvailabilitySearchModel } from "@/shared/models/availability";
import NumericPicker from "./NumericPicker.vue";
import { PropertyType } from "@/shared/models/propertyType";
import { JwtClaims } from "@/store/modules/auth";
import { policyChecker } from "@/shared/roles";
import NumericInput from "@/components/misc/NumericInput.vue";
import CurrencyDisplay from "@/components/misc/CurrencyDisplay.vue";
import { FinancialSettingsType } from "@/store/modules/financial";
import { AmenityView } from "@/shared/models/amenities";
import { Category } from "@/shared/models/category";

@Component({
  components: {
    DateField,
    NumericPicker,
    NumericInput,
    CurrencyDisplay,
  },
})
export default class MobileFilterModal extends Vue {
  @PropSync("open") internalOpen?: boolean;
  @PropSync("dialogOpen") globalFilterOpen?: boolean;
  @Prop() filterType?: string;
  @Prop() filterPrefill?: any;
  @Prop() sortOptions?: {
    text: string;
    value: string;
  }[];
  @Prop() sortPrefil?: {
    sortBy: "";
    desc: boolean;
  };
  @Prop({ default: true }) isGlobalSearch?: boolean;

  @Getter("auth/claims") claims?: JwtClaims;
  
  @Action("codebooks/refreshCategories") refreshCategories?: () => Promise<void>;
  @Getter("codebooks/categories") categories?: Category[];

  @Getter("financial/settings") storedSettings?: FinancialSettingsType;
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;
  
  @Action("codebooks/refreshAmenitiesAndGroups")
  refreshAmenitiesAndGroups?: () => Promise<void>;
  @Getter("codebooks/amenities") amenities?: AmenityView[];

  @Getter("language/language") language?: string;
  @Action("codebooks/refreshPropertyTypes")
  refreshPropertyTypes?: () => Promise<void>;
  @Getter("codebooks/propertyTypes") propertyTypes?: PropertyType[];

  async created() {
    const promises = [];

    if ((this.propertyTypes?.length ?? 0) === 0 && this.refreshPropertyTypes) {
      promises.push(this.refreshPropertyTypes());
    }
    if ((this.categories?.length ?? 0) === 0 && this.refreshCategories) {
      promises.push(this.refreshCategories());
    }
    if (
      (this.amenities?.length ?? 0) === 0 && this.refreshAmenitiesAndGroups) {
      promises.push(this.refreshAmenitiesAndGroups());
    }
    if (this.storedSettings?.workingCurrency && this.refreshSettings) {
      promises.push(this.refreshSettings());
    }

    await Promise.all(promises);
  }

  nameFilter = "";
  addressFilter = "";
  postalCodeFilter = "";
  eMailFilter = "";
  telephoneNumberFilter = "";
  ownerFilter = "";
  propertyTypeFilter=[] as string[];

  cityId?: number = 0;
  
  dateRangeDates: string[] = [];

  reservationId = "";
  arrivalOrDepartureDate = "";
  arrivalDateFromPeriod = "";
  arrivalDateToPeriod = "";
  departureDateFromPeriod = "";
  departureDateToPeriod = "";
  bookingDate = "";
  isFilteredByDate: boolean | null = null;
  optionExpirationDate = "";
  reservationHolderName = "";
  accomodationUnitName = "";
  accomodationUnitTypeName = "";
  statusId: number | null = null;
  serviceTypeName = "";

  sortBy = "";
  sortDesc = false;

  statuses = reservationStatuses;
  
  availabilitySearchModel: AvailabilitySearchModel = new AvailabilitySearchModel();

  @Getter("codebooks/accomodationUnitStatuses")
  accomodationUnitStatuses?: AccomodationUnitStatus[];

  mounted() {
    this.setUpRules();
  }

  //when we open global filter, open and clear filter
  @Watch("dialogOpen", { immediate: true })
  globalFilterOpenChanged(){
    if (this.globalFilterOpen){
      this.availabilitySearchModel = new AvailabilitySearchModel();
      this.availabilitySearchModel.numberOfUnits = this.filterPrefill.numberOfUnits;
      this.availabilitySearchModel.numberOfAdults = this.filterPrefill.numberOfAdults;
      this.availabilitySearchModel.numberOfChildren = this.filterPrefill.numberOfChildren;
      this.availabilitySearchModel.numberOfBedrooms = this.filterPrefill.numberOfBathrooms;
      this.availabilitySearchModel.numberOfBathrooms = this.filterPrefill.numberOfBedrooms;
      this.dateRangeDates = [];
      this.internalOpen = true;
    }
  }

  isFormValid = false;
  get submitDisabled(): boolean {
    if(this.filterType === "availability"){
      return this.dateRangeDates.length != 2;
    }
    return !this.isFormValid;
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  @Watch("dateRangeDates")
  dateRangeDatesWatch() {
    if (this.dateRangeDates.length == 2) {
      if (this.dateRangeDates[1] < this.dateRangeDates[0]) {
        this.dateRangeDates = this.dateRangeDates.reverse();
      }
    }
  }

  get sortedPropertyTypes() {
    return (
      this.propertyTypes?.map((x) => {
        return {
          value: x.id,
          name: this.$t(x.textResourceKey),
        };
      }) ?? []
    ).sort((a, b) => (a.name > b.name ? 1 : -1));
  }

  get currencyId(){
    return this.storedSettings?.workingCurrency.id;
  }

  get arrivalDatePeriod() {
    const res = [
      this.arrivalDateFromPeriod
        ? this.arrivalDateFromPeriod.substring(0, 10) ?? ""
        : "",
      this.arrivalDateToPeriod
        ? this.arrivalDateToPeriod.substring(0, 10) ?? ""
        : "",
    ].filter((x) => !!x) as string[];
    return res;
  }

  set arrivalDatePeriod(val: string[]) {
    if (val && _.isArray(val)) {
      this.arrivalDateFromPeriod = val.length > 0 ? val[0] : "";
      this.arrivalDateToPeriod = val.length > 1 ? val[1] : "";
    }
    //reset value when user clears data
    else {
      this.arrivalDateFromPeriod = "";
      this.arrivalDateToPeriod = "";
    }
  }

  get departureDatePeriod() {
    const res = [
      this.departureDateFromPeriod
        ? this.departureDateFromPeriod.substring(0, 10) ?? ""
        : "",
      this.departureDateToPeriod
        ? this.departureDateToPeriod.substring(0, 10) ?? ""
        : "",
    ].filter((x) => !!x) as string[];
    return res;
  }

  set departureDatePeriod(val: string[]) {
    if (val && _.isArray(val)) {
      this.departureDateFromPeriod = val.length > 0 ? val[0] : "";
      this.departureDateToPeriod = val.length > 1 ? val[1] : "";
    }
    //reset value when user clears data
    else {
      this.departureDateFromPeriod = "";
      this.departureDateToPeriod = "";
    }
  }
  
  get uniqueAmenities(){
    const uniqueAmenities = [] as AmenityView[];
    // Push only unique values.
    this.amenities?.forEach(x => {
      if(!uniqueAmenities.map(uT => uT.textResourceKey).includes(x.textResourceKey)){
        uniqueAmenities.push(x);
      }
    })
    
    return uniqueAmenities;    
  }

  citiesSearchInput = "";
  cities: City[] = [];
  loadingCities = false;
  @Watch("citiesSearchInput")
  citiesSearchWatch(fresh: string) {
    if (!fresh) {
      this.availabilitySearchModel.cityId = undefined;
      this.cities = [];
    }
    this.debouncedSearchCities();
  }
  debouncedSearchCities = _.debounce(this.searchCities, 500);
  searchCities() {
    if (!this.citiesSearchInput) {
      return;
    }

    this.loadingCities = true;
    this.axios
      .get<ListModel<City>>("codebooks/cities", {
        params: {
          name: this.citiesSearchInput,
        },
      })
      .then((res) => {
        this.cities = res.data.result;
        this.loadingCities = false;
      });
  }

  @Watch("open")
  onOpenChanged(fresh: boolean, old: boolean) {
    if (fresh && !old){
      const promises = [];
      if ((this.propertyTypes?.length ?? 0) === 0 && this.refreshPropertyTypes) {
        promises.push(this.refreshPropertyTypes());
      }
      Promise.all(promises);
    }
    if (this.filterType !== 'reservation') {
      this.accomodationUnitName = "";
      this.statusId = null;
    }
    this.nameFilter = "";
    this.addressFilter = "";
    this.postalCodeFilter = "";
    this.eMailFilter = "";
    this.telephoneNumberFilter = "";
    this.accomodationUnitTypeName = "";
    this.serviceTypeName = "";
    this.ownerFilter="";
    this.propertyTypeFilter=[];

    if (this.filterPrefill) {
      this.nameFilter = this.filterPrefill.name;
      this.eMailFilter = this.filterPrefill.eMail;
      this.telephoneNumberFilter = this.filterPrefill.telephoneNumber;
    }

    if (this.sortPrefil) {
      this.sortBy = this.sortPrefil.sortBy;
      this.sortDesc = this.sortPrefil.desc;
    }
  }

  @Watch("$route")
  routeChanged() {
    this.internalOpen = false;
  }

  get showEmail() {
    return policyChecker("READ_CUSTOMER_EMAIL")(this.claims)
  }

  get isAllowedToSeeTelephoneNumber() {
    return policyChecker("READ_CUSTOMER_TELEPHONE_NUMBER")(this.claims)
  }

    
  @Watch("dateFilterApplied", { immediate: true })
  applyDateFilterSwitch(filters: any) {
    this.$emit("filterUpdated", filters);
  }

  apply() {
    const filters = {
      nameFilter: this.availabilitySearchModel.propertyName ? this.availabilitySearchModel.propertyName : this.nameFilter,
      addressFilter: this.addressFilter,
      postalCodeFilter: this.postalCodeFilter,
      eMailFilter: this.eMailFilter,
      telephoneNumberFilter: this.telephoneNumberFilter,
      ownerFilter: this.ownerFilter,
      propertyTypeFilter: this.propertyTypeFilter,

      cityId: this.availabilitySearchModel.cityId,

      dateRangeDates: this.dateRangeDates,
      includeOnlyWholeProperties: this.availabilitySearchModel.includeOnlyWholeProperties,
      ignoreRestrictions: this.availabilitySearchModel.ignoreRestrictions,
      ignoreUnitTypeCount: this.availabilitySearchModel.ignoreUnitTypeCount,
      includeSpecialOffers: this.availabilitySearchModel.includeSpecialOffers,

      numberOfUnits: this.availabilitySearchModel.numberOfUnits,
      numberOfAdults: this.availabilitySearchModel.numberOfAdults,
      numberOfChildren: this.availabilitySearchModel.numberOfChildren,
      numberOfBedrooms: this.availabilitySearchModel.numberOfBedrooms,
      numberOfBathrooms: this.availabilitySearchModel.numberOfBathrooms,
      fromPrice: this.availabilitySearchModel.fromPrice,
      toPrice: this.availabilitySearchModel.toPrice,
      distanceToBeach: this.availabilitySearchModel.distanceToBeach,
      distanceToCityCenter: this.availabilitySearchModel.distanceToCityCenter,

      petsAllowed: this.availabilitySearchModel.petsAllowed,
      propertyTypes: this.availabilitySearchModel.propertyTypes,
      categories: this.availabilitySearchModel.categories,
      amenities: this.availabilitySearchModel.amenities,

      reservationId: this.reservationId,
      arrivalOrDepartureDate: this.arrivalOrDepartureDate,
      arrivalDateFromPeriod: this.arrivalDateFromPeriod,
      arrivalDateToPeriod: this.arrivalDateToPeriod,
      departureDateFromPeriod: this.departureDateFromPeriod,
      departureDateToPeriod: this.departureDateToPeriod,
      bookingDate: this.bookingDate,
      isFilteredByDate: this.isFilteredByDate,
      optionExpirationDate: this.optionExpirationDate,
      reservationHolderName: this.reservationHolderName,
      accomodationUnitName: this.accomodationUnitName,
      accomodationUnitTypeName: this.accomodationUnitTypeName,
      statusId: this.statusId,
      serviceTypeName: this.serviceTypeName,

      sortBy: this.sortBy,
      sortDesc: this.sortDesc,
    };
    this.$emit("filterUpdated", filters);
    this.internalOpen = false;
  }

  rules = {};

  setUpRules() {
    this.rules = {
      Required: [
        (value: any) =>
          !!value || value === 0 || this.$t("Validation.Required"),
      ],
      NoNegativeNumbers: [
        (value: number) =>
          value == null ||
          value == undefined ||
          value >= 0 ||
          this.$t("Validation.MustBePositive"),
      ],
      WholeNumbersOnly: [
        (value: number) =>
          value == null ||
          value == undefined ||
          value % 1 == 0 ||
          this.$t("Validation.MustBeWholeNumber"),
      ],
    };
  }
  close(){
    this.internalOpen = false;
    this.$emit("closingFilterModal");
  }
}
